import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface HorizontalListCSSStyle extends UIComponentCSSStyle
{
    
}

export class HorizontalListCSSStyleImpl extends UIComponentCSSStyleImpl implements HorizontalListCSSStyle
{

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/horizontallistcss.tsx